import React, { lazy } from "react";
import { Route } from "react-router-dom";
import RouteSuspense from "../RouteSuspense";

const Dashboard = lazy(() => import("../../pages/dashboard/Dashboard"));
const Sales = lazy(() => import("../../pages/sales/Sales"));
const AccountManagement = lazy(() => import("../../pages/account/AccountManagement"));
const AccountOTP = lazy(() => import("../../pages/account/AccountOTP"));
const AccessManagement = lazy(() => import("../../pages/access/AccessManagement"));
const Reports = lazy(() => import("../../pages/reports/Reports"));
const ReportRecords = lazy(() => import("../../pages/reports/ReportRecords"));
const SystemLogs = lazy(() => import("../../pages/reports/SystemLogs"));
const BillInventory = lazy(() => import("../../pages/reports/Bills/BillInventory/BillInventory"));
const BillHistory = lazy(() => import("../../pages/reports/Bills/BillHistory/BillHistory"));
const BillOTPWrapper = lazy(() => import("../../component/BillOTPWrapper"));
const CustomerDetails = lazy(() =>
  import("../../pages/reports/Customer/CustomerInfo/CustomerDetails")
);
const CustomerHistory = lazy(() =>
  import("../../pages/reports/Customer/CustomerHistory/CustomerHistory")
);
const CustomerModule = lazy(() => import("../../pages/customers/CustomerModule"));
const ReceiptConfig = lazy(() => import("../../pages/receipt/ReceiptConfig"));
const ReceiptTest = lazy(() => import("../../pages/receipt/ReceiptTest"));
const VoucherModule = lazy(() => import("../../pages/vouchers/VoucherModule"));
const AccountToggles = lazy(() => import("../../pages/account/AccountToggles"));
const ReceiptServiceCharge = lazy(() => import("../../pages/receipt/ReceiptServiceCharge"));
const ReceiptGrossSales = lazy(() => import("../../pages/receipt/ReceiptGrossSales"));
const ReceiptKioskConfig = lazy(() => import("../../pages/receipt/ReceiptKioskConfig"));
const ReceiptKdsConfig = lazy(() => import("../../pages/receipt/ReceiptKdsConfig"));
const ReceiptTermsConfig = lazy(() => import("../../pages/receipt/ReceiptTermsConfig"));
const Promotions = lazy(() => import("../../pages/promotions/Promotion"));
const PromoHome = lazy(() => import("../../pages/promotions/PromoHome"));
const PromoBrands = lazy(() => import("../../pages/promotions/PromoBrands"));
const PromoSounds = lazy(() => import("../../pages/promotions/PromoSounds"));
const PromoColors = lazy(() => import("../../pages/promotions/PromoColors"));

const BusinessLiveRoutes = () => (
  <>
    <Route path="/dashboard" element={<RouteSuspense><Dashboard /></RouteSuspense>} />
    <Route path="/salesstats" element={<RouteSuspense><Sales /></RouteSuspense>} />
    <Route path="/account-management" element={<RouteSuspense><AccountManagement /></RouteSuspense>} />
    <Route path="/account-management/otps" element={<RouteSuspense><AccountOTP /></RouteSuspense>} />
    <Route path="/account-management/toggles" element={<RouteSuspense><AccountToggles /></RouteSuspense>} />
    <Route path="/access-management" element={<RouteSuspense><AccessManagement /></RouteSuspense>} />
    <Route path="/reports" element={<RouteSuspense><Reports /></RouteSuspense>} />
    <Route path="/reports/records" element={<RouteSuspense><ReportRecords /></RouteSuspense>} />
    <Route path="/reports/system-logs" element={<RouteSuspense><SystemLogs /></RouteSuspense>} />
    <Route
      path="/reports/bill-inventory"
      element={
        <RouteSuspense>
          <BillOTPWrapper><BillInventory /></BillOTPWrapper>
        </RouteSuspense>
      }
    />
    <Route
      path="/reports/bill-history"
      element={
        <RouteSuspense>
          <BillOTPWrapper><BillHistory /></BillOTPWrapper>
        </RouteSuspense>
      }
    />
    <Route path="/reports/customer-details" element={<RouteSuspense><CustomerDetails /></RouteSuspense>} />
    <Route path="/reports/customer-history" element={<RouteSuspense><CustomerHistory /></RouteSuspense>} />
    <Route path="/customers" element={<RouteSuspense><CustomerModule /></RouteSuspense>} />
    <Route path="/config" element={<RouteSuspense><ReceiptConfig /></RouteSuspense>} />
    <Route path="/config-print" element={<RouteSuspense><ReceiptTest /></RouteSuspense>} />
    <Route
      path="/config-service-charge"
      element={<RouteSuspense><ReceiptServiceCharge /></RouteSuspense>}
    />
    <Route path="/config-gross-sales" element={<RouteSuspense><ReceiptGrossSales /></RouteSuspense>} />
    <Route path="/config-kiosk" element={<RouteSuspense><ReceiptKioskConfig /></RouteSuspense>} />
    <Route path="/config-kds" element={<RouteSuspense><ReceiptKdsConfig /></RouteSuspense>} />
    <Route path="/config-terms" element={<RouteSuspense><ReceiptTermsConfig /></RouteSuspense>} />
    <Route path="/vouchers" element={<RouteSuspense><VoucherModule /></RouteSuspense>} />
    <Route path="/promotions" element={<RouteSuspense><Promotions /></RouteSuspense>} />
    <Route path="/promotions/home" element={<RouteSuspense><PromoHome /></RouteSuspense>} />
    <Route path="/promotions/brands" element={<RouteSuspense><PromoBrands /></RouteSuspense>} />
    <Route path="/promotions/sounds" element={<RouteSuspense><PromoSounds /></RouteSuspense>} />
    <Route path="/promotions/colors" element={<RouteSuspense><PromoColors /></RouteSuspense>} />
  </>
);

export default BusinessLiveRoutes;
